<div class="w-full flex flex-col h-full box-border">
    <div
        [class]="
            'border-t-2 border-b p-4 cursor-pointer bg-gradient-to-b text-base text-[#CCCCCC] font-bold ' +
            headerClasses
        "
    >
        {{ heading }}
    </div>
    <div
        class="grid grid-cols-[1fr_2fr_2fr_1fr_3fr_2fr_2fr_2fr] data-[show-options=true]:grid-cols-[1fr_2fr_2fr_1fr_3fr_2fr_2fr_2fr_1fr] gap-2 border-b border-shs-gray-4 mt-2"
        [attr.data-show-options]="showOptions"
    >
        <div class="text-font-tertiary px-2 py-4 text-xs truncate">COD</div>
        <div class="text-font-tertiary px-2 py-4 text-xs truncate">Created on</div>
        <div class="text-font-tertiary px-2 py-4 text-xs truncate">Created by</div>
        <div class="text-font-tertiary px-2 py-4 text-xs truncate">Country</div>
        <div class="text-font-tertiary px-2 py-4 text-xs truncate">Nature of complaint</div>
        <div class="text-font-tertiary px-2 py-4 text-xs truncate">Reference Number</div>
        <div class="text-font-tertiary px-2 py-4 text-xs truncate">Current Assignee</div>
        <div class="text-font-tertiary px-2 py-4 text-xs truncate">Status</div>
        @if (showOptions) {
        <div class="text-font-tertiary px-2 py-4 text-xs truncate">Actions</div>
        }
    </div>
    <div class="flex-grow overflow-y-auto overscroll-contain pb-40 mb-4 box-content" #table>
        @for (item of items; track $index) {
        <div
            class="grid grid-cols-[1fr_2fr_2fr_1fr_3fr_2fr_2fr_2fr] data-[show-options=true]:grid-cols-[1fr_2fr_2fr_1fr_3fr_2fr_2fr_2fr_1fr] gap-2 border-b border-shs-gray-4 cursor-pointer hover:bg-shs-gray-4"
            [attr.data-show-options]="showOptions"
            (click)="rowClick.emit(item)"
        >
            <div class="text-font-tertiary px-2 py-4 text-left text-base font-bold truncate flex items-center gap-2">
                <span [class]="'w-[2px] h-[80%] inline-block border-l-2 ' + borderClasses"></span>
                {{ item.serial }}
            </div>
            <div class="text-font-tertiary px-2 py-4 text-left text-base truncate">
                {{ item.createdAt | date }}
            </div>
            <div class="text-font-tertiary px-2 py-4 text-left text-base truncate">
                {{ item.createdBy | user | async }}
            </div>
            <div class="text-font-tertiary px-2 py-4 text-left text-base truncate">
                {{ item.shipToCountryCode }}
            </div>
            <div class="text-font-tertiary px-2 py-4 text-left text-base truncate">
                {{ item.natureOfComplaint }}
            </div>
            <div class="text-font-tertiary px-2 py-4 text-left text-base truncate">
                {{ item.referenceNumber }}
            </div>
            <div class="text-font-tertiary px-2 py-4 text-left text-base truncate">
                {{ item.assignedTo | user | async }}
            </div>
            <div class="text-font-tertiary px-2 py-4 text-left text-base truncate flex items-center gap-2">
                <span class="h-2 w-2 bg-shs-orange rounded-full inline-block"></span> {{ item.status }}
            </div>
            @if (showOptions) {
            <div
                class="text-font-tertiary px-2 py-4 text-left text-base truncate flex items-center justify-end gap-2"
                (click)="$event.preventDefault(); $event.stopPropagation()"
            >
                <span
                    class="icon-options-vertical text-base text-font-tertiary cursor-pointer"
                    [menuOffsetTop]="12"
                    sag-ui-menu-trigger
                    [menuTriggerFor]="item.id + '_actions_menu'"
                ></span>
                <sag-ui-menu [menu]="item.id + '_actions_menu'" class="max-h-72">
                    <!-- Copy function removed -->
                    <!-- <sag-ui-menu-item (click)="copy(item.id!)">
                        <span class="flex items-center gap-2"> <span class="icon-copy"></span> Copy </span>
                    </sag-ui-menu-item>
                    <sag-ui-menu-item-divider></sag-ui-menu-item-divider> -->
                    <sag-ui-menu-item (click)="deleteCod(item.id!)">
                        <span class="flex items-center gap-2"> <span class="icon-delete"></span> Delete </span>
                    </sag-ui-menu-item>
                </sag-ui-menu>
            </div>
            }
        </div>
        } @if (isLoading$()) {
        <div class="bg-shs-gray-4 rounded-md w-full h-14 animate-pulse my-2"></div>
        <div class="bg-shs-gray-4 rounded-md w-full h-14 animate-pulse my-2 opacity-90"></div>
        <div class="bg-shs-gray-4 rounded-md w-full h-14 animate-pulse my-2 opacity-80"></div>
        <div class="bg-shs-gray-4 rounded-md w-full h-14 animate-pulse my-2 opacity-70"></div>
        <div class="bg-shs-gray-4 rounded-md w-full h-14 animate-pulse my-2 opacity-60"></div>
        <div class="bg-shs-gray-4 rounded-md w-full h-14 animate-pulse my-2 opacity-50"></div>
        } @if (!isLoading$() && items.length === 0) {
        <div class="text-font-tertiary text-center text-base py-14">No data available</div>
        }
    </div>
</div>
